import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { ITabPanelHeader } from '@design-system/components/m-tab-view/m-tab-view.component.types';

export interface IDimensionNavigationConfig {
  label: string;
  id: string;
  span: number;
  showCount: boolean;
  count: number;
  isSelected: boolean;
}

@Component({
  selector: 'portal-data-grid-dimension-navigator',
  templateUrl: './data-grid-dimension-navigator.component.html',
  standalone: false
})
export class DataGridDimensionNavigatorComponent implements OnInit, OnChanges {
  @Input() configs: IDimensionNavigationConfig[] = [];
  @Input() loading = true;
  @Output() selectedDimensionNavigation = new EventEmitter();
  activeIndex = 0;
  tabPanelHeaders: ITabPanelHeader[] = [];

  ngOnInit(): void {
    this.setActiveIndexForTab();
    this.buildTabPanelHeaders();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.countByFields || changes.configs || changes.loading) {
      if (changes.configs) {
        this.configs = changes.configs.currentValue;
      }
      this.setActiveIndexForTab();
      this.buildTabPanelHeaders();
    }
  }

  tabChange(index: number): void {
    this.selectedDimensionNavigation.next(this.configs[index]);
  }

  setActiveIndexForTab(): void {
    this.configs.forEach((config, index) => {
      if (config.isSelected) {
        this.activeIndex = index;
      }
    });
  }

  buildTabPanelHeaders(): void {
    this.tabPanelHeaders = this.configs.map((config) => ({
      header: config.label,
      disabled: false,
      showCount: config.showCount,
      count: config.count
    }));
  }
}
